import PosthogService from '~/services/posthog/PosthogService';

export interface IBulkConfirmReviewClickedPayload {
  professionalId?: string;
  candidateId?: string;
  shiftId?: string;
  offerId?: string;
}

/**
 * Fires when the user clicks "Review" on the "review additional applications" popup.
 *
 * `shiftId` / `offerId` identify the just-confirmed shift and offer that triggered
 * the popup, not the shifts being navigated to. `candidate_count` is 1 — this popup
 * is about a single professional (GOTU-4815).
 *
 * Event: dental_portal:bulk_confirm:review_clicked
 */
export function fireBulkConfirmReviewClicked(
  payload: IBulkConfirmReviewClickedPayload = {},
): void {
  PosthogService.getInstance().track('dental_portal:bulk_confirm:review_clicked', {
    professional_id: payload.professionalId,
    candidate_id: payload.candidateId,
    shift_id: payload.shiftId,
    offer_id: payload.offerId,
    candidate_count: 1,
  });
}
